<script>
import StoreService from '@/services/StoreService'
import SellerCard from './SellerCard.vue'
import ReviewCard from './ReviewCard'

export default {
  name: 'ReviewsBlock',

  components: {
    ReviewCard,
    SellerCard
  },

  props: {
    product: {
      type: Object,
      required: true
    }
  },

  async fetch () {
    this.reviewsShortInfo = (await StoreService.getReviewStatsBySellerId(this.$axios, this.product?.account_id))?.data?.data
    this.reviews = (await StoreService.getReviewsBySellerId(this.$axios, this.product?.account_id, 1, 20))?.data?.data?.reviews
  },

  data () {
    return {
      reviews: undefined,
      reviewsShortInfo: undefined
    }
  },

  methods: {
    countByRating (rating) {
      if (!this.reviewsShortInfo) {
        return 0
      }

      return +(this.reviewsShortInfo.find(info => info.rating === rating)?.count || 0)
    },

    percentByRating (rating) {
      if (!this.reviewsShortInfo) {
        return 0
      }

      return Math.round(this.countByRating(rating) * 100 / this.product.reviews_amount) + '%'
    }
  }
}
</script>

<template>
  <div :class="$style.container">
    <div :class="$style.title">
      {{ $t("sellerRating") }}
    </div>

    <div :class="$style.body">
      <div :class="$style.stats">
        <SellerCard :class="$style.seller" :product="product" no-chat light />

        <div :class="$style.shortStat">
          <div v-for="i in [5,4,3,2,1]" :key="`stars_row_${i}`">
            <div :class="$style.starsRow">
              <div :class="$style.stars">
                <img v-for="j in i" :key="`star_${j}`" :class="$style.star" :src="require('~/assets/img/icons/star-gold.svg')" alt="star" />
                <img v-for="j in (5 - i)" :key="`no_star_${j}`" :class="$style.star" :src="require('~/assets/img/icons/star-grey.svg')" alt="star empty" />
              </div>

              <div :class="$style.reviewsLine">
                <div :class="$style.reviewsLineFilled" :style="{width: percentByRating(i)}"></div>
              </div>

              <span :class="$style.reviewsText">{{ countByRating(i) }}</span>
            </div>
          </div>
        </div>
      </div>

      <div :class="$style.reviews">
        <div v-for="review in reviews" :key="review.id">
          <ReviewCard :review="review" />
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" module>
.container {
  background: $blue-grey70;
  border-radius: 8px;
  overflow: hidden;
}

.title {
  padding: 16px;
  border-bottom: 1px solid $blue-grey40;
  font-size: 20px;
  font-weight: 700;
  line-height: 24px;
  color: $white;
}

.body {
  padding: 20px 16px;
}

.stats {
  padding: 12px;
  background: $blue-grey60;
  border-radius: 8px;
}

.seller {
  border-bottom: 1px solid $blue-grey40;
}

.shortStat {
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 12px;
  margin: 12px 0;
}

.stars {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-right: 8px;
}

.star {
  width: 20px;
  height: 20px;
}

.starsRow {
  display: grid;
  grid-template-columns: max-content 1fr 60px;
  grid-gap: 12px;
  align-items: center;
}

.reviewsText {
  color: $white;
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  text-align: right;
}

.reviewsLine {
  width: 100%;
  height: 4px;
  background: $blue-grey40;
  border-radius: 4px;
  overflow: hidden;

  &Filled {
    width: 0;
    height: 100%;
    background: #FFF000;
    background: radial-gradient(at center, #FFF000, #FFB11B);
  }
}

.reviews {
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 16px;
  margin: 24px 0;
}
</style>
